module.exports = __webpack_public_path__ + "img/logo.3b1a09c5.png";